import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'

import { RoleContent } from '../RoleContent'

interface Props extends React.PropsWithChildren {
  member: TeammateDto
  onClick: (...keys: string[]) => void
  personal: boolean
  disabled: boolean
}

export const MemberDropdown: React.FC<Props> = ({
  member,
  onClick,
  children,
  personal,
  disabled,
}) => {
  const { role, activity, id } = member
  const onMenuClick = (keys: string[]) => onClick(...keys, id)

  return (
    <DropdownMenu.Root
      content={RoleContent}
      onClick={onMenuClick}
      current={role}
      activity={activity}
      personal={personal}
      disabled={disabled}
    >
      {children}
    </DropdownMenu.Root>
  )
}
